module.exports = __webpack_public_path__ + "static/media/icon-dashboard-project.c6debff5.svg";